import React from 'react';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import GridContainer from 'components/UI/Grid/GridContainer';
// our components
import { useQueryString } from 'helpers/effects';
import ExchangeRateList from 'components/ExchangeRate/List';

const ScreenExchangeRateList = () => {
  const initialFilters = useQueryString();
  return (
    <GridContainer>
      <GridItem xs={12}>
        <ExchangeRateList initialFilters={initialFilters} />
      </GridItem>
    </GridContainer>
  );
};
export default ScreenExchangeRateList;
